import VueScrollTo from 'vue-scrollto';

/*
export default defineNuxtPlugin((nuxtApp) => {
      nuxtApp.vueApp.use(VueScrollTo);
});
*/

export default defineNuxtPlugin({
  //name: 'my-plugin',
  //dependsOn: ['my-plugin'],
  parallel: true,
  async setup(nuxtApp) {
    nuxtApp.vueApp.use(VueScrollTo);
  }
});
